<script>
export let msg;

</script>



<style>

.error {

}

.error p {
	color: var(--text-grey);
	text-align: center;
	font-size: 1.375rem;
}

</style>



<section class="hero" style="border-bottom: none !important;">

	<div class="hero-body" style="padding-top: 6rem !important;">

		<div class="container">

			<div class="error">
				<p>
					{#if msg}
					{msg}
					{:else}
					Error!
					{/if}
				</p>
			</div>

		</div>

	</div>

</section>

